var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"notes"}},[_c('ul',{staticClass:"notes main-notes-list timeline",attrs:{"id":"notes-list"}},_vm._l((_vm.allNotes),function(note){return _c(_vm.getComponentName(note),{key:note.id,tag:"component",attrs:{"note":_vm.getComponentData(note)}})})),_vm._v(" "),_c('comment-form',{attrs:{"noteable-type":_vm.noteableType}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ecc149a6","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./notes/components/notes_app.vue
// module id = null
// module chunks = 